export default __webpack_public_path__ + "static/media/AF.427f40cb.svg";